import React, { Component } from 'react'
import {
  MessageComponentProps,
  MessageBubble,
  MessageBubbleText,
  FirebaseMessage
} from '@deal/chat-firebase'
import { Image, Avatar } from '@deal/components'
import ExpertRating from '#src/components/Reviews/ExpertRatingModal'
import styles from './styles.css'
import { ChatLeadComponent, MessageRichCardType } from '#src/generated/graphql'

interface State {
  showExpertRating: boolean
}

export default class FeedbackRequest extends Component<MessageComponentProps, State> {
  constructor(props: MessageComponentProps) {
    super(props)

    this.state = { showExpertRating: false }

    this.handleExpertRatingToggle = this.handleExpertRatingToggle.bind(this)
  }

  public handleExpertRatingToggle(showExpertRating: boolean) {
    this.setState({ showExpertRating })
  }

  public static handlesMessage(message: FirebaseMessage) {
    return (
      (message.parts[0].body.type === 'feedback-request-by-expert' ||
        message.parts[0].body.richCardType === MessageRichCardType.FEEDBACK_REQUEST_FROM_EXPERT) &&
      message.parts[0].body.queryVariables &&
      message.parts[0].body.queryVariables.leadId
    )
  }

  public render() {
    const leadId = this.props.message.parts[0].body.queryVariables.leadId

    return (
      <ChatLeadComponent variables={{ leadId }}>
        {({ data, loading }) => {
          if (loading) {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Loading...
              </MessageBubbleText>
            )
          } else if (data && data.lead) {
            const { expert } = data.lead

            const name = [expert.firstName, expert.lastName].filter(Boolean).join(' ')
            const category = data.lead.category

            const banner = category && category.contentAssets.bannerImages[0]
            const categoryName = category && category.singularDisplayName

            return (
              <>
                <ExpertRating
                  isOpen={this.state.showExpertRating}
                  onCloseModal={() => this.handleExpertRatingToggle(false)}
                  expertProfileId={data.lead.expert.id}
                />
                <MessageBubble message={this.props.message}>
                  <div className={styles.hero}>
                    {banner &&
                      banner.imageUrl && (
                        <Image
                          src={banner.imageUrl}
                          width={384}
                          height={134}
                          imgixParams={{ fit: 'crop' }}
                          className={styles.heroImage}
                        />
                      )}
                    <div className={styles.overlay}>
                      {expert.expertProfile &&
                        expert.expertProfile.profilePhoto && (
                          <div className={styles.avatarContainer}>
                            <Avatar
                              size={80}
                              name={name}
                              src={expert.expertProfile.profilePhoto.url}
                            />
                          </div>
                        )}
                      <div className={styles.name}>{name}</div>
                      <div className={styles.category}>Your {categoryName} Expert</div>
                    </div>
                  </div>
                  <div className={styles.cta} onClick={() => this.handleExpertRatingToggle(true)}>
                    Give feedback on {expert.firstName}
                  </div>
                </MessageBubble>
              </>
            )
          } else {
            return (
              <MessageBubbleText message={this.props.message} myself={this.props.myself}>
                Error loading message!
              </MessageBubbleText>
            )
          }
        }}
      </ChatLeadComponent>
    )
  }
}
